const stockProductData = {
  Id: 1,
  boxLines: [
    {
      rowList: [
        { title: "订单号：", banding: "AgentOrderNo", value: "B253535", className: "c-code-color" },
        { title: "入库日期：", banding: "InDate", value: "", dataType: "Date" }
      ]
    },
    {
      rowList: [{ title: "型号：", banding: "PartNo", value: "" }]
    },
    {
      rowList: [
        { title: "品牌：", banding: "Brand", value: "" },
        { title: "商品名称：", banding: "ProductName", value: "" }
      ]
    },
    {
      rowList: [
        { title: "年份(D/C): ", banding: "MakeAge", value: "" },
        { title: "产地：", banding: "RegionName", value: "" }
      ]
    },
    {
      rowList: [
        { title: "库存数量：", banding: "InvQty", value: "", className: "c-qty-color" },
        { title: "币别：", banding: "CurrencyType", value: "" }
      ]
    },
    {
      rowList: [
        { title: "单价：", banding: "UnitPrice", value: "" },
        { title: "单位：", banding: "Unit", value: "" }
      ]
    }
  ]
};
const stockOrderData = {
  Id: 1,
  boxLines: [
    {
      rowList: [
        { title: "订单号：", banding: "AgentOrderNo", value: "B253535", className: "c-code-color" },
        { title: "入库日期：", banding: "InDate", value: "", dataType: "Date" }
      ]
    },

    {
      rowList: [
        { title: "库存件数：", banding: "InvPackageCount", value: "" },
        { title: "库存重量：", banding: "InvWeight", value: "" }
      ]
    },
    {
      rowList: [
        { title: "库存卡板数: ", banding: "InvBoardCount", value: "" },
        { title: "库存体积：", banding: "InvVolume", value: "" }
      ]
    }
  ]
};
export { stockOrderData, stockProductData };
